<template>
  <main class="pp-page--registration">
    <h1 class="title title--desktop" v-t="'message.register_success'"></h1>
    <div class="pp-layout-container pp-layout-container--single">
      <section class="pp-main-content">
        <div class="reg-content">
          <h1 v-t="'message.register_success'" class="title title--mobile"></h1>
          <p v-t="'message.register_confirmation_email'"></p>
          <h4 v-if="event.sponsor">{{ event.sponsor }}</h4>
          <h4>{{ event.registrationEvent.title }}</h4>
          <h4>{{ localisedDate }}</h4>
        </div>

        <div class="reg-success-actions">
          <a class="btn--secondary" :href="getWhatsOnUrl">{{ $t('register.registration_complete')}}</a>
          <a class="btn--secondary" :href="getSignupUrl" v-if="!user.userLoggedIn">{{ $t('register.registration_sign_up_prompt')}}</a>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import moment from 'moment-timezone'
import { mapActions, mapGetters, mapState } from "vuex"
import FancyButton from "@/components/generic/FancyButton";

export default {
  name: 'registration-success',
  components: {
    FancyButton
  },
  watch: {
    "$i18n.locale": function() {
      this.languageSwitch();
    }
  },
  created() {
    this.clearError();
    this.updateStage('registration-success')
  },
  methods: {
     async languageSwitch() {
      await this.retrieveRegistrationSessions(this.$route.params.event)
    },
    ...mapActions(['retrieveRegistrationSessions', 'clearError', 'updateStage'])
  },
  computed: {
    localisedDate() {
      let momentLocale = "en";

      switch (this.$i18n.locale) {
        case "tc":
          momentLocale = "zh-HK";
        case "sc":
          momentLocale = "zh-CN";
      }

      moment.locale(momentLocale);

      // Times are given to us in local with Hong Kong timezone attached. We always want
      // to display times in local Hong Kong time. If we don't specify it will convert to
      // the users local browser time.
      if (momentLocale == 'en') {
        return moment(this.event.sessionSelected.date).tz('Asia/Hong_Kong').format(
          "dddd, DD MMMM YYYY h:mma z"
        );
      } else {
        return moment(this.event.sessionSelected.date).tz('Asia/Hong_Kong').format(
          "dddd, LL, a h:mm z"
        );
      }
    },
    ...mapState(['event', 'user']),
    ...mapGetters(['getSignupUrl', 'getWhatsOnUrl'])
  }
}
</script>